import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import './Branding_Title_Component.css';

const Branding_Title_Component = ({ updateBreadcrumb }) => {
  const { id } = useParams(); // Get 'id' from URL params
  const [titleData, setTitleData] = useState({
    title: '',
    descn: ''
  });

  const data = [
    {
      id: 1,
      imgSrc1 :"/Assets/Images/Service/Services_inner/Logo_Design/LOGO_Designing_1.png",
      imgSrc2 :"/Assets/Images/Service/Services_inner/Logo_Design/LOGO_Designing_2.png",
      imgSrc3 :"/Assets/Images/Service/Services_inner/Logo_Design/LOGO_Designing_3.png",
      title: "LOGO Designing",
      descn: "A logo is more than just a visual— it’s the identity of your brand. A well-designed logo captures your brand’s essence, creates a lasting impression, and builds recognition. Let us help you create a logo that speaks volumes about your business."
    },
    {
      id: 2,
      imgSrc1 :"/Assets/Images/Service/Services_inner/Graphic_Designing/Graphic-Designing-1.png",
    
      imgSrc2 :"/Assets/Images/Service/Services_inner/Graphic_Designing/Graphic-Designing-2.png",
      imgSrc3 :"/Assets/Images/Service/Services_inner/Graphic_Designing/Graphic-Designing-3.png",
      title: "Graphic Designing",
      descn: "Graphic design is the art of visual storytelling, combining creativity and strategy to communicate your brand’s message effectively. Whether it’s social media creatives, marketing materials, or branding assets, we create designs that captivate your audience and elevate your brand."
    },
    {
      id: 3,
      imgSrc1 :"/Assets/Images/Service/Services_inner/Brand_Design/Brand-Design-1.png",
      imgSrc2 :"/Assets/Images/Service/Services_inner/Brand_Design/Brand-Design-2.png",
      imgSrc3 :"/Assets/Images/Service/Services_inner/Brand_Design/Brand-Design-3.png",
      title: "Brand Design",
      descn: "Brand design is about crafting a cohesive visual identity that reflects your business&#39;s values, personality, and mission. From logos to typography, colour schemes to marketing materials, we help create a brand that resonates with your audience and stands out in the market."
    },
  ];

  useEffect(() => {
    const filteredData = data.find(item => item.id === Number(id));
    if (filteredData) {
      setTitleData(filteredData);
      // Update breadcrumb in parent component
      updateBreadcrumb(filteredData.title);
    }
  }, [id, updateBreadcrumb]);

  return (
    <section className='Branding_Title_Component'>
      <div className='container'>
        <div className='row'>
          <div className='col-lg-6 col-md-6 col-sm-12 col-12 order-md-1 order-sm-2 order-2'>
            <div className='title_div'>
              <p className='title'>{titleData?.title}</p>
            </div>
            <div className='descn_div'>
              <p className='descn'>{titleData?.descn}</p>
            </div>
          </div>

          {/* Image section as is */}
          <div className='col-lg-6 col-md-6 col-sm-12 order-md-2 order-sm-1 order-1'>
            <div className='row'>
              <div className='col-lg-8 col-md-8 col-sm-8 col-8'>
                <div className='big_img_holder'>
                  <img src={titleData?.imgSrc1} className='big_img' alt="Main image" />
                </div>
              </div>
              <div className='col-lg-4 col-md-4 col-sm-4 col-4'>
                <div className='row row_holder'>
                  <div className='col-lg-12 col-md-12 mb-2'>
                    <img src={titleData?.imgSrc2} className='first_img' alt="Image 1" />
                  </div>
                  <div className='col-lg-12 col-md-12'>
                    <img src={titleData?.imgSrc3} className='second_img' alt="Image 2" />
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Branding_Title_Component;
